import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricParticipationCount extends MetricBase {
    constructor() {
        super({
            field: "metric_participationCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.participationCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.participationCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.participationCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricParticipationCount;
